/*--------------
V 0.0.1 - Criado por Larner Diogo

DESCRICAO:
Serviço de armazenamento LocalStorage


COMPONENTS
***********************************************************/
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**********************************************************
PROVIDERS
***********************************************************/

@Injectable()
export class StorageService {

    /************
    GET STORAGE
    *************/
    getItem(item) { return sessionStorage.getItem(item); }

    /************
    SET STORAGE
    *************/
    setItem(item, valor) { return sessionStorage.setItem(item, valor); }

    /************
    DELETE STORAGE
    *************/
    removeItem(item) { return sessionStorage.removeItem(item); }

}


// WEBPACK FOOTER //
// ./src/app/globals/storage.ts